import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadApprovalLevels(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;

    let approvalLevels = getState().document.decision.approvalLevels[key];
    if (approvalLevels) {
      loading = approvalLevels.loading;
      loaded = approvalLevels.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_APPROVAL_LEVELS_STARTED, id: key });
      approvalLevels = await dispatch(sendHttpRequest(api.loadApprovalLevels(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_APPROVAL_LEVELS_SUCCESS, payload: approvalLevels, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadApprovalTypeDecisionReasons(approvalTypeId) {
  return async (dispatch, getState) => {
    let decisionReasons = getState().document.decision.approvalTypeDecisionReasons[approvalTypeId];

    if (decisionReasons?.loading || decisionReasons?.loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_STARTED, id: approvalTypeId });

      const decisionReasons = await dispatch(sendHttpRequest(api.getApprovalTypeDecisionReasons(approvalTypeId)));
      dispatch({
        type: actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_SUCCESS,
        payload: decisionReasons,
        id: approvalTypeId
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_FAILED, id: approvalTypeId });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateApprovalLevel(documentId, siteId, approvalLevel, isUpdateRequestedUserIdRequest, callback = () => { }) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateApprovalLevel(documentId, siteId, approvalLevel, isUpdateRequestedUserIdRequest),
          "updateApprovalLevelCommand",
          [eventTypes.DECISION_APPROVAL_LEVEL_UPDATED]
        )
      );

      if (event.ok) {
        dispatch({ type: actionTypes.APPROVAL_LEVEL_UPDATED, payload: approvalLevel, id: key });
        callback(true);
      }
      else
        callback(false);
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      callback(false);
      throw error;
    }
  };
}

export function applyApprovalLevel(documentId, siteId, approvalLevel, callback = () => { }) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.applyApprovalLevel(documentId, siteId, approvalLevel),
          "applyApprovalLevelCommand",
          [eventTypes.DECISION_APPROVAL_LEVEL_APPLIED]
        )
      );

      if (event.ok) {
        dispatch({ type: actionTypes.APPROVAL_LEVEL_UPDATED, payload: approvalLevel, id: key });
      }
      callback();
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      callback();
      throw error;
    }
  };
}

export function loadApprovalsHistory(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    dispatch({ type: actionTypes.LOAD_APPROVALS_HISTORY_STARTED, id: key });
    const approvalsHistory = await dispatch(sendHttpRequest(api.loadApprovalsHistory(documentId, siteId)));
    dispatch({ type: actionTypes.LOAD_APPROVALS_HISTORY_SUCCESS, payload: approvalsHistory, id: key });
  };
}

export function invalidateApprovalsHistory(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    dispatch({ type: actionTypes.APPROVALS_HISTORY_INVALIDATED, id: key });
  };
}
